import { Component, computed, inject, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Badge } from 'excellence-ui';
import { EnergyInterfacesStore } from '../../../energy-interfaces/stores/energy-interfaces.store';
import { getEnergyInterfaces, SupplierContractData } from '../../stores/supplier-contracts.store';

@Component({
  selector: 'app-supplier-contract-energy-interfaces',
  imports: [Badge, TranslocoPipe],
  templateUrl: './supplier-contract-energy-interfaces.html',
})
export class SupplierContractEnergyInterfaces {
  private energyInterfacesStore = inject(EnergyInterfacesStore);

  supplierContract = input.required<SupplierContractData>();

  protected energyInterfaces = computed(() =>
    getEnergyInterfaces(
      this.supplierContract(),
      this.energyInterfacesStore.energyInterfaces() ?? [],
    ),
  );
}
